import { useEffect, useState } from "react";
import { getUserProfile, modifySubscription } from "helpers";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";

const useNewsletter = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userAuth0, setUserAuth0] = useState(null);
  const [showNewsletters, setShowNewsletters] = useState(false);
	const [userId, setUserId] = useState("");
	const [dataSubscription, setDataSubscription] = useState(null);
  const [subscriberIds, setSubscriberIds] = useState([]);

  const getUserIdByEmail = async () => {
    const response = await fetch(`/api/eloqua/userIdByEmail/${userAuth0.email}`,{method: 'POST'});
    const { data } = await response.json();
    setUserId(data?.[0]?.id ?? "");
	}

  const getDataSubscription = async () => {
    const response = await fetch(`/api/eloqua/isSubscribed/${userId}`,{method: 'POST'});
    const { data } = await response.json(); 
    if(data) {
      const suscribed = data.filter(element => element.isSubscribed);
      setDataSubscription(suscribed)
      if (suscribed.length > 0) {
        setSubscriberIds(filterSubscriberIds(suscribed));
      }
    } else {
      setDataSubscription([]);
    }
	}

  const filterSubscriberIds = (suscribed) => {
    return suscribed?.filter(sub => sub.isSubscribed === "true").map(sub => sub.emailGroup.id);
  }

  const subscribe = async (subscriptionUrl, isPremiun, idGroup, extras) => {
    if (!userAuth0 || !userAuth0.email) {
      console.error("User not authenticated");
      return;
    };
    if (isPremiun && userAuth0?.subscriptionStatus !== "subscribed") {
      window.location.href = `https://www.clarin.com/suscripciones/suscribite.html`;
    } else {
      const succesSuscription = await modifySubscription(
        userAuth0?.email ?? "",
        subscriptionUrl,
        { isFromNews: extras.isFromNews ?? false }
      );
      if (succesSuscription) {
        setSubscriberIds((prevIds) => [...prevIds, String(idGroup)]);
      }
    }
  };

  const handleSubscribe = (newsletter, section, extras) => {
    try {
      handleClick("ui_interaction", section, "subscribe-newsletter");
      subscribe(
        newsletter.extras?.subscriptionUrl,
        newsletter.extras?.premium,
        newsletter.extras?.idGroup,
        { isFromNews: extras.isFromNews ?? false }
      );
    } catch (error) {
      console.error("Error subscribing to newsletter:", error);
    }
  };

  useEffect(() => {
    let data = getUserProfile();
    setUserAuth0(data);
  }, []);

  useEffect(() => {
    if (userAuth0?.email) {
      setShowNewsletters(true);
      getUserIdByEmail();
    }
  }, [userAuth0]);

  useEffect(() => {
    if(userId) {
      getDataSubscription(userId)
    };
	}, [userId])

  useEffect(() => {
    if (dataSubscription === null) return;
    setIsLoading(false);
	}, [dataSubscription])

  return { 
    dataSubscription,
    showNewsletters,
    userAuth0,
    userId,
    userEmail: userAuth0?.email ?? "",
    subscriberIds,
    isLoading,
    setSubscriberIds,
    handleSubscribe,
    filterSubscriberIds };
};

export default useNewsletter;
